module.exports = __webpack_public_path__ + "static/img/fgbg1-7.50e92b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/fgbg1-7.png
// module id = 185
// module chunks = 0